
import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister } from "../../store/user/actions/actionCreators";
import { ProviderRegisterSchemas } from "../../Schemas/Schemas";
import SpinNer from "../LoadingSpinner/SpinNer";

const stateOptions = [
  { value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' }, { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' }, { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' },
];

const initialValues = {
  firstName: "", middleName: "", lastName: "",
  address1: "", address2: "", city: "", state: "", zipCode: "",
  mobilePhone: "", email: "", password: "", confirmPassword: "", role: "",
};

const EyeOpen = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeClosed = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="2,7 6,11 12,3" />
  </svg>
);

const STEPS = [
  { id: 1, num: "01", label: "Personal", title: "Step 1" },
  { id: 2, num: "02", label: "Address",  title: "Step 2" },
  { id: 3, num: "03", label: "Account",  title: "Step 3" },
];

const ProviderRegisterForm = () => {
  const { isLoading } = useSelector((state) => state.user);
  const [roleValue, setRoleValue] = useState("");
  const [eye, setEye] = useState(false);
  const [confirmEye, setConfirmEye] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const RegisterHandler = (values, action) => {
    const data = {
      middleName: values.middleName,
      email: values.email,
      password: values.password,
      role: roleValue,
      firstName: values.firstName,
      lastName: values.lastName,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zipCode: values.zipCode,
      mobilePhone: values.mobilePhone,
      playerStatus: 'ACTIVE',
      personAPlayer: roleValue === 'PLAYER',
    };
    dispatch(userRegister(data, navigate));
    action.resetForm();
  };

  const progressWidth = `${(currentStep / 3) * 100}%`;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=Barlow:wght@300;400;500;600&display=swap');

        .reg-root {
          min-height: 100vh;
          background: #000000;
          font-family: 'Barlow', sans-serif;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 32px 16px 60px;
          position: relative;
          overflow-x: hidden;
        }

        .reg-watermark {
          position: fixed;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: clamp(100px, 20vw, 260px);
          font-weight: 800;
          color: rgba(255,255,255,0.016);
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none; z-index: 0;
          white-space: nowrap; letter-spacing: 0.04em;
          user-select: none;
        }

        /* CARD */
        .reg-card {
          position: relative; z-index: 1;
          width: 100%; max-width: 1020px;
          background: rgba(14,17,24,0.96);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 24px;
          box-shadow:
            0 0 0 1px rgba(179,0,0,0.12),
            0 50px 100px rgba(0,0,0,0.7),
            inset 0 1px 0 rgba(255,255,255,0.07);
          overflow: hidden;
          backdrop-filter: blur(24px);
          margin-top: 8px;
        }

        /* HEADER */
        .reg-header {
          background: linear-gradient(140deg, #1c0808 0%, #0d1420 55%, #0a0c10 100%);
          padding: 44px 52px 38px;
          border-bottom: 1px solid rgba(179,0,0,0.22);
          display: flex;
          align-items: center;
          gap: 28px;
          position: relative;
          overflow: hidden;
        }

        .reg-header::before {
          content: '';
          position: absolute; top: -60px; right: -60px;
          width: 280px; height: 280px; border-radius: 50%;
          
          pointer-events: none;
        }

        .reg-header::after {
          content: '';
          position: absolute; bottom: 0; left: 0; right: 0; height: 2px;
         
        }

        .reg-logo {
          width: 180px; height: auto;
         
          flex-shrink: 0;
        }

        .reg-header-copy { flex: 1; }

        .reg-header-copy h1 {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 800;
          color: #fff;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          line-height: 1;
          margin-bottom: 8px;
        }

        .reg-header-copy h1 em { color: #b30000; font-style: normal; }

        .reg-header-copy p {
          font-size: 12px; font-weight: 500;
          letter-spacing: 0.1em; text-transform: uppercase;
          color: rgba(255,255,255,0.38); line-height: 1.4;
        }

        .reg-badge {
          background: rgba(179,0,0,0.12);
          border: 1px solid rgba(179,0,0,0.3);
          border-radius: 20px; padding: 6px 18px;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 11px; font-weight: 700;
          letter-spacing: 0.12em; text-transform: uppercase;
          color: #cc0000; white-space: nowrap;
          align-self: flex-start; margin-top: 4px;
        }

        /* PROGRESS */
        .reg-prog-bar { height: 3px; background: rgba(255,255,255,0.05); }
        .reg-prog-fill {
          height: 100%;
          background: #b30000;
          transition: width 0.45s cubic-bezier(0.4,0,0.2,1);
          box-shadow: 0 0 10px rgba(179,0,0,0.55);
        }

        /* STEP TABS */
        .reg-steps {
          display: flex;
          background: rgba(0,0,0,0.35);
          border-bottom: 1px solid rgba(255,255,255,0.05);
          padding: 0 52px; gap: 4px;
        }

        .reg-step-tab {
          flex: 1; display: flex; align-items: center;
          gap: 12px; padding: 22px 8px 20px;
          cursor: default; position: relative;
          border-bottom: 2.5px solid transparent;
          transition: border-color 0.25s; user-select: none;
        }

        .reg-step-tab.active { border-bottom-color: #b30000; }
        .reg-step-tab.done   { border-bottom-color: rgba(179,0,0,0.28); cursor: pointer; }

        .reg-step-bubble {
          width: 38px; height: 38px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 14px; font-weight: 700;
          background: rgba(255,255,255,0.05);
          border: 1.5px solid rgba(255,255,255,0.1);
          color: rgba(255,255,255,0.4);
          flex-shrink: 0; transition: all 0.25s;
        }

        .reg-step-tab.active .reg-step-bubble {
          background: rgba(179,0,0,0.18); border-color: #b30000;
          color: #cc0000; box-shadow: 0 0 16px rgba(179,0,0,0.28);
        }

        .reg-step-tab.done .reg-step-bubble {
          background: rgba(179,0,0,0.12); border-color: rgba(179,0,0,0.4); color: #cc0000;
        }

        .reg-step-info { display: flex; flex-direction: column; gap: 2px; }

        .reg-step-num {
          font-size: 10px; font-weight: 600;
          letter-spacing: 0.1em; text-transform: uppercase;
          color: rgba(255,255,255,0.25);
        }

        .reg-step-tab.active .reg-step-num { color: #b30000; }

        .reg-step-name {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 16px; font-weight: 700;
          letter-spacing: 0.06em; text-transform: uppercase;
          color: rgba(255,255,255,0.28); transition: color 0.2s;
        }

        .reg-step-tab.active .reg-step-name,
        .reg-step-tab.done .reg-step-name { color: rgba(255,255,255,0.78); }

        /* BODY */
        .reg-body { padding: 44px 52px 36px; animation: regFadeUp 0.3s ease; }

        @keyframes regFadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .reg-section-heading {
          display: flex; align-items: center;
          gap: 14px; margin-bottom: 30px;
        }

        .reg-section-label {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 11px; font-weight: 700;
          letter-spacing: 0.16em; text-transform: uppercase;
          color: #b30000; white-space: nowrap;
        }

        .reg-section-line {
          flex: 1; height: 1px;
          background: linear-gradient(90deg, rgba(179,0,0,0.25), transparent);
        }

        /* GRIDS */
        .reg-g3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; }
        .reg-g2 { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
        .reg-g1 { display: grid; grid-template-columns: 1fr; gap: 20px; }
        .reg-s2 { grid-column: span 2; }

        /* FIELD */
        .reg-field { display: flex; flex-direction: column; gap: 8px; }

        .reg-field-label {
          font-size: 11px; font-weight: 600;
          letter-spacing: 0.09em; text-transform: uppercase;
          color: rgba(255,255,255,0.4); padding-left: 2px;
        }

        .reg-req { color: #b30000; margin-left: 2px; }

        .reg-iw { position: relative; display: flex; align-items: center; }

        .reg-input, .reg-select {
          width: 100%;
          background: #ffffff;
          border: 1.5px solid rgba(0,0,0,0.15);
          border-radius: 10px;
          padding: 14px 18px;
          color: #111111;
          font-family: 'Barlow', sans-serif;
          font-size: 15px; font-weight: 400;
          transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
          outline: none; appearance: none; -webkit-appearance: none;
        }

        .reg-input::placeholder { color: rgba(0,0,0,0.35); }

        .reg-input:hover, .reg-select:hover {
          border-color: rgba(0,0,0,0.3);
          background: #f9f9f9;
        }

        .reg-input:focus, .reg-select:focus {
          border-color: #b30000;
          background: #ffffff;
          box-shadow: 0 0 0 3.5px rgba(179,0,0,0.12);
        }

        .reg-select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='rgba(0,0,0,0.4)' stroke-width='1.8' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
          padding-right: 42px; cursor: pointer;
          color: #333333;
        }

        .reg-select option { background: #ffffff; color: #111111; }

        .reg-input.has-right { padding-right: 48px; }

        .reg-eye {
          position: absolute; right: 14px;
          background: none; border: none; cursor: pointer;
          color: rgba(0,0,0,0.35);
          display: flex; align-items: center;
          transition: color 0.15s; padding: 4px;
        }

        .reg-eye:hover { color: rgba(0,0,0,0.7); }

        .reg-error {
          font-size: 11px; color: #cc0000;
          letter-spacing: 0.03em; padding-left: 2px;
        }

        /* NAV */
        .reg-nav {
          display: flex; align-items: center; justify-content: space-between;
          padding: 24px 52px 38px;
          border-top: 1px solid rgba(255,255,255,0.05);
          gap: 16px;
        }

        .reg-nav-left { display: flex; align-items: center; gap: 16px; }

        .reg-step-ctr {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 13px; font-weight: 700;
          letter-spacing: 0.08em; text-transform: uppercase;
          color: rgba(255,255,255,0.22);
        }

        .reg-btn {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 15px; font-weight: 700;
          letter-spacing: 0.1em; text-transform: uppercase;
          padding: 15px 40px; border-radius: 10px;
          border: none; cursor: pointer;
          transition: all 0.2s; white-space: nowrap;
          display: inline-flex; align-items: center; gap: 8px;
        }

        .reg-btn-ghost {
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.45);
          border: 1.5px solid rgba(255,255,255,0.09);
        }

        .reg-btn-ghost:hover { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.8); }

        .reg-btn-primary {
          background: linear-gradient(135deg, #b30000, #7f0000);
          color: #fff;
          box-shadow: 0 5px 20px rgba(179,0,0,0.38);
          border: 1.5px solid rgba(255,80,80,0.15);
        }

        .reg-btn-primary:hover {
          background: linear-gradient(135deg, #cc0000, #b30000);
          box-shadow: 0 8px 28px rgba(179,0,0,0.52);
          transform: translateY(-2px);
        }

        .reg-btn-primary:active { transform: translateY(0); }
        .reg-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

        /* FOOTER */
        .reg-footer {
          text-align: center; padding: 0 52px 38px;
          font-size: 14px; color: rgba(255,255,255,0.32);
        }

        .reg-footer a { color: #cc0000; text-decoration: none; font-weight: 600; }
        .reg-footer a:hover { color: #e53935; }

        /* RESPONSIVE */
        @media (max-width: 860px) {
          .reg-steps  { padding: 0 28px; }
          .reg-body   { padding: 32px 28px 28px; }
          .reg-nav    { padding: 18px 28px 32px; }
          .reg-footer { padding: 0 28px 32px; }
          .reg-header { padding: 32px 28px 28px; gap: 20px; }
          .reg-g3 { grid-template-columns: 1fr 1fr; }
          .reg-s2 { grid-column: span 2; }
        }

        @media (max-width: 600px) {
          .reg-root { padding: 0 0 40px; }
          .reg-card { border-radius: 0; border-left: none; border-right: none; box-shadow: none; min-height: 100vh; }
          .reg-header { padding: 24px 18px 22px; flex-direction: column; align-items: flex-start; gap: 14px; }
          .reg-logo { width: 82px; }
          .reg-badge { display: none; }
          .reg-steps { padding: 0 18px; }
          .reg-step-tab { padding: 16px 4px 14px; gap: 8px; }
          .reg-step-bubble { width: 32px; height: 32px; font-size: 12px; }
          .reg-step-info { display: none; }
          .reg-body   { padding: 26px 18px 22px; }
          .reg-nav    { padding: 16px 18px 28px; flex-direction: column; align-items: stretch; gap: 10px; }
          .reg-nav-left { justify-content: space-between; order: 2; }
          .reg-btn-primary { width: 100%; justify-content: center; }
          .reg-footer { padding: 0 18px 28px; }
          .reg-g3, .reg-g2 { grid-template-columns: 1fr; }
          .reg-s2 { grid-column: span 1; }
          .reg-btn { padding: 14px 28px; }
        }
      `}</style>

      <div className="reg-root">
        <div className="reg-watermark">USMLSA</div>

        <div className="reg-card">

          {/* HEADER */}
          <div className="reg-header">
            <img className="reg-logo" src="https://usmlsa.com/wp-content/uploads/2023/10/usmlsa_new_png-Copy.png" alt="USMLSA" />
            <div className="reg-header-copy">
              <h1>Create Your <em>Account</em></h1>
              <p>United States Major League Sports Association · Member Registration</p>
            </div>
            <div className="reg-badge">New Member</div>
          </div>

          {/* PROGRESS BAR */}
          <div className="reg-prog-bar">
            <div className="reg-prog-fill" style={{ width: progressWidth }} />
          </div>

          {/* STEP TABS */}
          <div className="reg-steps">
            {STEPS.map((s) => {
              const isActive = currentStep === s.id;
              const isDone   = currentStep > s.id;
              return (
                <div
                  key={s.id}
                  className={`reg-step-tab${isActive ? ' active' : ''}${isDone ? ' done' : ''}`}
                  onClick={() => isDone && setCurrentStep(s.id)}
                >
                  <div className="reg-step-bubble">
                    {isDone ? <CheckIcon /> : s.num}
                  </div>
                  <div className="reg-step-info">
                    <span className="reg-step-num">{s.title}</span>
                    <span className="reg-step-name">{s.label}</span>
                  </div>
                </div>
              );
            })}
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={ProviderRegisterSchemas}
            onSubmit={RegisterHandler}
          >
            {({ values, handleChange, handleBlur, errors, touched }) => (
              <Form>

                {/* ── STEP 1 — Personal ── */}
                {currentStep === 1 && (
                  <div className="reg-body">
                    <div className="reg-section-heading">
                      <span className="reg-section-label">👤 Personal Information</span>
                      <div className="reg-section-line" />
                    </div>
                    <div className="reg-g3">
                      <div className="reg-field">
                        <label className="reg-field-label">First Name <span className="reg-req">*</span></label>
                        <Field name="firstName" placeholder="John" className={`reg-input${errors.firstName && touched.firstName ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="firstName" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Middle Name</label>
                        <Field name="middleName" placeholder="Optional" className="reg-input" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Last Name <span className="reg-req">*</span></label>
                        <Field name="lastName" placeholder="Smith" className={`reg-input${errors.lastName && touched.lastName ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="lastName" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field reg-s2">
                        <label className="reg-field-label">Role <span className="reg-req">*</span></label>
                        <Field
                          as="select"
                          name="role"
                          className={`reg-select${errors.role && touched.role ? ' reg-input-error' : ''}`}
                          onChange={(e) => { handleChange(e); setRoleValue(e.target.value); }}
                        >
                          <option value="">— Select Your Role —</option>
                          <option value="MANAGER">Manager</option>
                        </Field>
                        <ErrorMessage name="role" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Mobile Phone <span className="reg-req">*</span></label>
                        <Field name="mobilePhone" placeholder="(555) 000-0000" className={`reg-input${errors.mobilePhone && touched.mobilePhone ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="mobilePhone" component="div" className="reg-error" />
                      </div>
                    </div>
                  </div>
                )}

                {/* ── STEP 2 — Address ── */}
                {currentStep === 2 && (
                  <div className="reg-body">
                    <div className="reg-section-heading">
                      <span className="reg-section-label">📍 Address Details</span>
                      <div className="reg-section-line" />
                    </div>
                    <div className="reg-g2">
                      <div className="reg-field reg-s2">
                        <label className="reg-field-label">Address Line 1 <span className="reg-req">*</span></label>
                        <Field name="address1" placeholder="123 Main Street" className={`reg-input${errors.address1 && touched.address1 ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="address1" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field reg-s2">
                        <label className="reg-field-label">Address Line 2</label>
                        <Field name="address2" placeholder="Apt, Suite, Floor (optional)" className="reg-input" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">City <span className="reg-req">*</span></label>
                        <Field name="city" placeholder="Los Angeles" className={`reg-input${errors.city && touched.city ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="city" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">State <span className="reg-req">*</span></label>
                        <Field as="select" name="state" className={`reg-select${errors.state && touched.state ? ' reg-input-error' : ''}`}>
                          <option value="">— Select State —</option>
                          {stateOptions.map((s) => (
                            <option key={s.value} value={s.value}>{s.label}</option>
                          ))}
                        </Field>
                        <ErrorMessage name="state" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Zip Code <span className="reg-req">*</span></label>
                        <Field name="zipCode" placeholder="90001" maxLength="10" className={`reg-input${errors.zipCode && touched.zipCode ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="zipCode" component="div" className="reg-error" />
                      </div>
                    </div>
                  </div>
                )}

                {/* ── STEP 3 — Account ── */}
                {currentStep === 3 && (
                  <div className="reg-body">
                    <div className="reg-section-heading">
                      <span className="reg-section-label">🔐 Account Security</span>
                      <div className="reg-section-line" />
                    </div>
                    <div className="reg-g1" style={{ maxWidth: 580, margin: '0 auto' }}>
                      <div className="reg-field">
                        <label className="reg-field-label">Email Address <span className="reg-req">*</span></label>
                        <Field name="email" type="email" placeholder="you@example.com" className={`reg-input${errors.email && touched.email ? ' reg-input-error' : ''}`} />
                        <ErrorMessage name="email" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Password <span className="reg-req">*</span></label>
                        <div className="reg-iw">
                          <Field name="password" type={eye ? "text" : "password"} placeholder="Create a strong password" className={`reg-input has-right${errors.password && touched.password ? ' reg-input-error' : ''}`} />
                          <button type="button" className="reg-eye" onClick={() => setEye(!eye)}>
                            {eye ? <EyeClosed /> : <EyeOpen />}
                          </button>
                        </div>
                        <ErrorMessage name="password" component="div" className="reg-error" />
                      </div>
                      <div className="reg-field">
                        <label className="reg-field-label">Confirm Password <span className="reg-req">*</span></label>
                        <div className="reg-iw">
                          <Field name="confirmPassword" type={confirmEye ? "text" : "password"} placeholder="Repeat your password" className={`reg-input has-right${errors.confirmPassword && touched.confirmPassword ? ' reg-input-error' : ''}`} />
                          <button type="button" className="reg-eye" onClick={() => setConfirmEye(!confirmEye)}>
                            {confirmEye ? <EyeClosed /> : <EyeOpen />}
                          </button>
                        </div>
                        <ErrorMessage name="confirmPassword" component="div" className="reg-error" />
                      </div>
                    </div>
                  </div>
                )}

                {/* NAV */}
                <div className="reg-nav">
                  <div className="reg-nav-left">
                    <button
                      type="button"
                      className="reg-btn reg-btn-ghost"
                      style={{ visibility: currentStep > 1 ? 'visible' : 'hidden' }}
                      onClick={() => setCurrentStep(currentStep - 1)}
                    >
                      ← Back
                    </button>
                    <span className="reg-step-ctr">Step {currentStep} of 3</span>
                  </div>

                  {currentStep < 3 ? (
                    <button type="button" className="reg-btn reg-btn-primary" onClick={() => setCurrentStep(currentStep + 1)}>
                      Continue →
                    </button>
                  ) : (
                    <button type="submit" className="reg-btn reg-btn-primary" disabled={isLoading}>
                      {isLoading ? <SpinNer /> : "Create Account →"}
                    </button>
                  )}
                </div>

                <p className="reg-footer">
                  Already have an account?{" "}
                  <Link to="/auth/login">Sign In</Link>
                </p>

              </Form>
            )}
          </Formik>

        </div>
      </div>
    </>
  );
};

export default ProviderRegisterForm;


/*
import React, { useState } from "react";
import { Image, Col, Row } from "react-bootstrap";
import { Formik, Form } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister } from "../../store/user/actions/actionCreators";
import TextField from "../../shared/TextField";
import SelectTag from "../product/SelectTag";
import { FaUser, FaAddressBook, FaMapMarkerAlt, FaMobileAlt, FaEnvelope, FaLock, FaUserTie, FaCity } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "../../assets/css/login-form.css";
import { ProviderRegisterSchemas } from "../../Schemas/Schemas";
import SpinNer from "../LoadingSpinner/SpinNer";

const ProviderRegisterForm = () => {
  const { isLoading } = useSelector((state) => state.user);
  const [roleValue, SetRoleValue] = useState("");
  const [eye, setEye] = useState(false);
  const [confirmEye, setConfirmEye] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const roleOptions = [
    { value: 'MANAGER', label: 'MANAGER' },
  ]

  // US States options for dropdown
  const stateOptions = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ];

  const initialValues = {
    firstName: "",
    middleName: "",
    lastName: "",
    address1: "",
    address2: "",
    points: null,
    ranking: null,
    division: "",
    city: "",
    state: "",
    zipCode: "",
    mobilePhone: "",
    email: "",
    password: "",
    confirmPassword: "",
    tournamentsPlayed: null,
    gamesPlayed: null,
    role: "",
  };


  const RegisterHandler = (values, action) => {
    const data = {
      middleName: values.middleName,
      email: values.email,
      password: values.password,
      role: roleValue,
      firstName: values.firstName,
      lastName: values.lastName,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zipCode: values.zipCode,
      mobilePhone: values.mobilePhone,
      playerStatus: 'ACTIVE',
      personAPlayer: roleValue === 'PLAYER' ? true : false,
    };
    dispatch(userRegister(data, navigate));
    action.resetForm();
  };

  return (
    <div className="p-4" >
      <div className="text-align-center d-flex justify-content-center flex-column align-items-center py-2">
        <Image
          fluid
          src="https://usmlsa.com/wp-content/uploads/2023/10/usmlsa_new_png-Copy.png"
          width={200}
          height={100}
        />
        <h2 className="auth-heading py-2 text-white">Register <span className="auth-special">Now</span></h2>
        <p className="auth-subheading text-white">Create your new account.</p>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={ProviderRegisterSchemas}
        onSubmit={RegisterHandler}
      >
        {({ values, handleChange, handleBlur, errors, touched }) => (
          <Form>
            <Row className="Signup-form row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 gy-3">
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="First Name"
                  name="firstName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="Middle Name (optional)"
                  name="middleName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="Last Name"
                  name="lastName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaAddressBook />}
                  placeholder="Address 1"
                  name="address1"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaAddressBook />}
                  placeholder="Address 2"
                  name="address2"
                  type="text"
                />
              </Col>
              <Col className="">
                <SelectTag
                  deFaultValue="Select Your Role"
                  icon={<FaUserTie className="me-2" size={20} />}
                  options={roleOptions}
                  className="d-flex flex-grow-1 bg-white"
                  name="role"
                  value={values.role}
                  onChange={(e) => {
                    handleChange(e);
                    SetRoleValue(e.target.value);
                  }}
                  onBlur={handleBlur}
                  error={errors.role}
                  touched={touched.role}
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaCity />}
                  placeholder="City"
                  name="city"
                  type="text"
                />
              </Col>
              <Col>
                <SelectTag
                  deFaultValue="Select State"
                  icon={<FaMapMarkerAlt className="me-2" size={20} />}
                  options={stateOptions}
                  className="d-flex flex-grow-1 bg-white"
                  name="state"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.state}
                  touched={touched.state}
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaMapMarkerAlt />}
                  placeholder="Zip Code"
                  name="zipCode"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaMobileAlt />}
                  placeholder="Mobile Phone"
                  name="mobilePhone"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaEnvelope />}
                  placeholder="Email"
                  name="email"
                  type="email"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaLock />}
                  righticon={
                    eye ? (
                      <AiFillEyeInvisible onClick={() => setEye(!eye)} />
                    ) : (
                      <AiFillEye onClick={() => setEye(!eye)} />
                    )
                  }
                  placeholder="Password"
                  name="password"
                  type={eye ? "text" : "password"}
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaLock />}
                  righticon={
                    confirmEye ? (
                      <AiFillEyeInvisible onClick={() => setConfirmEye(!confirmEye)} />
                    ) : (
                      <AiFillEye onClick={() => setConfirmEye(!confirmEye)} />
                    )
                  }
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  type={confirmEye ? "text" : "password"}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xs="12 d-flex flex-grow-1 justify-content-center">
                <button type="submit" className="h-56px gradient-btn-orange rounded">
                  {isLoading ? <SpinNer /> : "Submit"}
                </button>
              </Col>
            </Row>
            <p className="auth-subheading fw-bold text-center text-white">
              Already have an account?
              <Link to="/auth/login" className="text-decoration-none fs-6">
                <span className="forget ps-1">Login</span>
              </Link>
            </p>
          </Form>
        )}
      </Formik>

    </div>
  );
};

export default ProviderRegisterForm;

/*import React, { useState } from "react";
import { Image, Col, Row } from "react-bootstrap";
import { Formik, Form } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister } from "../../store/user/actions/actionCreators";
import TextField from "../../shared/TextField";
import SelectTag from "../product/SelectTag";
import { FaUser, FaAddressBook, FaMapMarkerAlt, FaMobileAlt, FaEnvelope, FaLock, FaUserTie, FaCity } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "../../assets/css/login-form.css";
import { ProviderRegisterSchemas } from "../../Schemas/Schemas";
import SpinNer from "../LoadingSpinner/SpinNer";
const ProviderRegisterForm = () => {
  const { isLoading } = useSelector((state) => state.user);
  const [roleValue, SetRoleValue] = useState("");
  const [eye, setEye] = useState(false);
  const [confirmEye, setConfirmEye] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const roleOptions = [
    { value: 'MANAGER', label: 'MANAGER' },
  ]

  const initialValues = {
    firstName: "",
    middleName: "",
    lastName: "",
    address1: "",
    address2: "",
    points: null,
    ranking: null,
    division: "",
    city: "",
    state: "",
    zipCode: "",
    mobilePhone: "",
    email: "",
    password: "",
    confirmPassword: "",
    tournamentsPlayed: null,
    gamesPlayed: null,
    role: "",
  };


  const RegisterHandler = (values, action) => {
    const data = {
      middleName: values.middleName,
      email: values.email,
      password: values.password,
      role: roleValue,
      firstName: values.firstName,
      lastName: values.lastName,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zipCode: values.zipCode,
      mobilePhone: values.mobilePhone,
      playerStatus: 'ACTIVE',
      personAPlayer: roleValue === 'PLAYER' ? true : false,
    };
    dispatch(userRegister(data, navigate));
    action.resetForm();
  };
  // const handleRole = (e) => {
  //   SetRoleValue(e.target.value);
  // };

  return (
    <div className="p-4" >
      <div className="text-align-center d-flex justify-content-center flex-column align-items-center py-2">
        <Image
          fluid
          src="https://usmlsa.com/wp-content/uploads/2023/10/usmlsa_new_png-Copy.png"
          width={200}
          height={100}
        />
        <h2 className="auth-heading py-2 text-white">Register <span className="auth-special">Now</span></h2>
        <p className="auth-subheading text-white">Create your new account.</p>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={ProviderRegisterSchemas}
        onSubmit={RegisterHandler}
      >
        {({ values, handleChange, handleBlur, errors, touched }) => (
          <Form>
            <Row className="Signup-form row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 gy-3">
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="First Name"
                  name="firstName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="Middle Name (optional)"
                  name="middleName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaUser />}
                  placeholder="Last Name"
                  name="lastName"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaAddressBook />}
                  placeholder="Address 1"
                  name="address1"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaAddressBook />}
                  placeholder="Address 2"
                  name="address2"
                  type="text"
                />
              </Col>
              <Col className="">
                <SelectTag
                  deFaultValue="Select Your Role"
                  icon={<FaUserTie className="me-2" size={20} />}
                  options={roleOptions}
                  className="d-flex flex-grow-1 bg-white"
                  name="role"
                  value={values.role}
                  onChange={(e) => {
                    handleChange(e);
                    SetRoleValue(e.target.value);
                  }}
                  onBlur={handleBlur}
                  error={errors.role}
                  touched={touched.role}
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaCity />}
                  placeholder="City"
                  name="city"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaMapMarkerAlt />}
                  placeholder="State"
                  name="state"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaMapMarkerAlt />}
                  placeholder="Zip Code"
                  name="zipCode"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaMobileAlt />}
                  placeholder="Mobile Phone"
                  name="mobilePhone"
                  type="text"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaEnvelope />}
                  placeholder="Email"
                  name="email"
                  type="email"
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaLock />}
                  righticon={
                    eye ? (
                      <AiFillEyeInvisible onClick={() => setEye(!eye)} />
                    ) : (
                      <AiFillEye onClick={() => setEye(!eye)} />
                    )
                  }
                  placeholder="Password"
                  name="password"
                  type={eye ? "text" : "password"}
                />
              </Col>
              <Col>
                <TextField
                  icon={<FaLock />}
                  righticon={
                    confirmEye ? (
                      <AiFillEyeInvisible onClick={() => setConfirmEye(!confirmEye)} />
                    ) : (
                      <AiFillEye onClick={() => setConfirmEye(!confirmEye)} />
                    )
                  }
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  type={confirmEye ? "text" : "password"}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xs="12 d-flex flex-grow-1 justify-content-center">
                <button type="submit" className="h-56px gradient-btn-orange rounded">
                  {isLoading ? <SpinNer /> : "Submit"}
                </button>
              </Col>
            </Row>
            <p className="auth-subheading fw-bold text-center text-white">
              Already have an account?
              <Link to="/auth/login" className="text-decoration-none fs-6">
                <span className="forget ps-1">Login</span>
              </Link>
            </p>
          </Form>
        )}
      </Formik>

    </div>
  );
};

export default ProviderRegisterForm;
*/